export default {
  SET_IS_OPEN: 'SET_IS_OPEN',
  LOGIN_WITH_REDIRECT: 'LOGIN_WITH_REDIRECT',
  LOGOUT: 'LOGOUT'
}
